// Home.js
import React from 'react';
import Table from '../components/Table';


const Home = () => {
  const styles = {
    title: {
      textAlign: 'center',
      fontSize: '28px',
      margin: 5,
    },
    description: {
      margin: 20,
    },

    h2: {
      fontSize: '22px'
    },
    paragraph: {
      fontSize: '18px',
      // textAlign: 'center',
    }
  }
  return (
    <div>
      <h1 style={styles.title}>CS:GO Case ROI</h1>
      <Table/>
      <div style={styles.description}>
        <p style={styles.paragraph}>CSGO Case ROI is an online tool designed to help users calculate the probability of obtaining specific items from cases based on community data. By utilizing this tool, users can assess the potential profits before opening cases.</p>
        <h2 style={styles.h2}>What is the best case to open in csgo?</h2>
        <p style={styles.paragraph}>The best case to open in CSGO can vary depending on various factors such as the current market value of the items, the rarity of the items, and the personal preference of the player. To maximize potential profits, it's essential to do comprehensive research and analysis before deciding on which case to open.</p>
      </div>
    </div>
  );
}

export default Home;
